import React from 'react';
import styled from 'styled-components/macro';
import SortMenu from 'src/client/components/Placeholders/Cards/SortMenuPlaceholder';
import { ModelCardPlaceholder } from '../Cards/ModelCardPlaceholder';
import { PaginationPlaceholder } from 'src/client/components/Placeholders/Cards/PaginationPlaceholder';

type Props = {
  count?: number;
  detailed?: boolean;
};

export const ModelsPlaceholder = (props: Props) => {
  const { detailed, count = 30 } = props;

  return (
    <div className="placeholder-wrap">
      <SortMenu />
      <CardsWrap>
        {[...Array(count)].map((elem, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <ModelCardPlaceholder detailed={detailed} key={i} />
        ))}
      </CardsWrap>
      <PaginationPlaceholder />
    </div>
  );
};

const CardsWrap = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;
